import React, { useState, useEffect } from "react";
import axiosConfig from "../../../Service/AxiosConfig";
import { useParams } from "react-router-dom";
import BlogComponent from "../BlogComponent/BlogComponent";
import BlogDetail from "../BlogComponent/BlogDetail";
import HomeNurse from "../HomeNurse/HomeNurse";
import CareGiver from "../CareGiver/CareGiver";
import BabyCare from "../BabyCare/BabyCare";
import Radiology from "../Radiology/Radiology";
import Physiotherapy from "../Physiotherapy/Physiotherapy";
import Medicinehome from "../MedicineHome/Medicinehome.jsx";
import MedicalEqu from "../MedicalEquipments/MedicalEqu";
import HomeIcu from "../HomeICUSetup/HomeIcu.jsx";
import Diagnostics from "../Diagnostics/Diagnostics.jsx";
import DoctorConsultation from "../DoctorConsultation/DoctorConsultation.jsx";
import HealthChecks from "../HealthChecks/HealthChecks.jsx";


const FriendlyUrlComponent = () => {
  const { seo_url } = useParams();
  const [loading, setLoading] = useState(true);
  const [productObject, setProductObject] = useState({
    product_type: "",
    product_data: null,
  });
  const [apiError, setApiError] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setApiError(false);

      try {
        const response = await axiosConfig.get(`/catlog/seo-url/${seo_url}/`);
        const data = response.data;
        setProductObject({
          product_type: data.product_type,
          product_data: data.product_data,
        });
      } catch (error) {
        console.warn("SEO API failed or slug not found:", error);
        setApiError(true);
        setProductObject({ product_type: "", product_data: null });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [seo_url]);
  useEffect(() => {
    if (loading) return;

    const baseUrl = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ""
      }`;
    const slug = productObject?.product_data?.slug || seo_url;
    const canonicalUrl = `${baseUrl}/${slug}`;

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = canonicalUrl;
  }, [loading, productObject, seo_url]);

  if (loading) {
    return (
      <div className="loader-container">
        <img
          src={require("../../Assets/loader.gif")}
          alt="Loading..."
          style={{ width: "50px", height: "50px" }}
        />
      </div>
    );
  }

  switch (productObject.product_type) {
    case "blogcategory":
      return <BlogComponent category={productObject.product_data?.id} />;
    case "blog":
      return <BlogDetail item={productObject.product_data} />;
    default:
      break;
  }
  switch (seo_url) {
    case "home-nurse":
      return <HomeNurse />;
    case "care-giver":
      return <CareGiver />;
    case "baby-care":
      return <BabyCare />;
    case "radiology":
      return <Radiology />;
    case "physiotherapy":
      return <Physiotherapy />;
    case "medicine-home-delivery":
      return <Medicinehome />;
    case "medical-equipment":
      return <MedicalEqu />;
    case "home-icu-setup":
      return <HomeIcu />;
    case "diagnostics":
      return <Diagnostics />;
    case "doctor-consultation":
      return <DoctorConsultation />;
      case "health-checks":
      return <HealthChecks/>;
      default:
      return <h3 className="text-center mt-5">Page not found</h3>;
  }
};

export { FriendlyUrlComponent };
